export const clientId = import.meta.env.VITE_CLIENT_ID;
export const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? 'http://localhost:5000';
export const fixed = import.meta.env.VITE_API_URL ?? 'http://localhost:3001/api/';

export const publicURL = `${fixed}email/gcpfiles/assets/public/`;
export const oldAssets = `${fixed}email/gcpfiles/public/storage/`;

export const gameUrl = `${fixed}email/games/public/storage/cyber-games/`;
export const DataProtectionURL = 'https://storage.googleapis.com/abi-ghq-cybersecurity-web-training/';

export const localAssets = '../images_public/';
export const downloadPDF = 'http://localhost:3001/';

export const gispVideos = `${fixed}email/games/public/storage/cyber-security/videos/GISP Video/`;
export const donloadDoc = `${fixed}email/games/public/storage/meme-document/`;
export const downloadPhisingDoc = `${fixed}email/games//public`;

export const localImages = `${fixed}email/gcpfiles/local_assets/images/`;
export const localVideos = `${fixed}email/gcpfiles/local_assets/videos`;
export const SecurityTraining = `${fixed}email/gcptraining/local_assets/SecurityTraining`;
export const ApplicationSecurity = `${fixed}email/gcptraining/local_assets/ApplicationSecurity`;

export const getWebinar = `${fixed}email/games//public/storage/webinar/`;
export const FifaPoster = `${fixed}email/assets/public/storage/fifa-posters/`;
export const BrewstarsTraining = `${fixed}email/gcptraining/local_assets/`;
export const getImage = `${fixed}email/gcpfiles/assets/`;
export const arrowimage = `${fixed}email/games/public/storage/`;
export const getWebinar2026 =`${fixed}email/gcpfiles/local_assets/videos`;